import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

/**
 * Focuses (and selects the text of, if applicable) the host element as soon
 * as it's rendered — used for the Layers panel's inline rename input, which
 * is only created on double-click via an `@if`, so the native `autofocus`
 * HTML attribute isn't reliably honored across browsers for that case.
 */
@Directive({
  selector: '[appAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  private el = inject(ElementRef<HTMLInputElement>);

  ngAfterViewInit(): void {
    queueMicrotask(() => {
      const nativeEl = this.el.nativeElement;
      nativeEl.focus();
      nativeEl.select?.();
    });
  }
}
